import { Route, Switch, useLocation } from "react-router-dom";
import ConversationsPage from "../pages/ConversationsPage";
import ExplorePage from "../pages/ExplorePage";
import HelpPage from "../pages/HelpPage";
import HomePage from "../pages/HomePage";
import SupportWidgetContainer from "./SupportWidgetContainer";

const Routes = ({ onClose }: { onClose: () => void }) => {
  const location = useLocation();

  const getPageName = () => {
    switch (location.pathname) {
      case "/":
        return "Home";
      case "/conversations":
        return "Conversations";
      case "/help":
        return "Help Page";
      case "/explore":
        return "Explore";
      default:
        return "Home";
    }
  };

  return (
    <SupportWidgetContainer onClose={onClose} pageName={getPageName()}>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/conversations" component={ConversationsPage} />
        <Route exact path="/help" component={HelpPage} />
        <Route exact path="/explore" component={ExplorePage} />
      </Switch>
    </SupportWidgetContainer>
  );
};

export default Routes;
